import useFilter from "hooks/useFilter/useFilter";
import { useMemo } from "react";

type SearchableEntity = {};

function useEntityTextSearch<T extends SearchableEntity>(searchText: string, items: T[], properties: (keyof T)[]) {
  const filterBy = useFilter();

  return useMemo(() => {
    if (!searchText) return items;

    const filteredItems: T[] = items.filter((item) => {
      const candidateKeywordString = properties
        .map((property) => {
          const value = item[property];
          if (Array.isArray(value)) {
            return value
              .filter((value) => typeof value === "string")
              .join(" ")
              .toUpperCase();
          }

          return value;
        })
        .filter((value) => typeof value === "string")
        .filter(Boolean)
        .join(" ");

      return filterBy(searchText, candidateKeywordString);
    });

    return filteredItems;
  }, [searchText, items, properties, filterBy]);
}

export default useEntityTextSearch;
